export default class QueriesController{
  _requestService;
  _paths;
  constructor(requestService, paths){
    this._requestService = requestService
    this._paths = paths
  }

  async fetchChildPlans({childId}){
    return await this._requestService.Get(this._paths.FETCH_CHILD_PLANS_PATH(childId))
  }

  async fetchPlanRememberOptions(){
    return await this._requestService.Get(this._paths.FETCH_REMEMBER_OPTIONS_PLAN_PATH)
  }

  async fetchCheckList({childId, date=null}){
    let params =  date?{date:date}:{}
    return await this._requestService.Get(this._paths.CHILD_CHECKLIST_PATH(childId),params)
  }

  async fetchChecklistDates({childId}){
    return await this._requestService.Get(this._paths.CHILD_CHECKLIST_DATES(childId))
  }
  async fetchCriterionTagsList(){
    try {
      const path = this._paths.CRITERION_TAGS_LIST
      const { data } = await this._requestService.Get(path)
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, Cannot obtain the tags.');
    }
  }
}